<div class="topbar">
  <!--<div class="topbar-menu" (click)="menuClick()"><span class="fa-solid fa-bars"></span></div>-->
  <div class="topbar-image">
    <img src="assets/images/logos/blue-logo.svg" alt="The ISG Logo in white" (click)="navHome()" style="cursor: pointer" />

  </div>
  <div class="topbar-impersonate">
    <app-impersonation-current (impersonateChanged)="onImpersonateChanged($event)">
    </app-impersonation-current>
  </div>
  <app-quicklinks></app-quicklinks>
  <div class="topbar-shortcuts">
    <!--  <app-apps-card></app-apps-card> -->
    <app-shortcuts-card></app-shortcuts-card>
  </div>
  <div class="topbar-admin" *ngIf="enableAdminicon"
       [ngClass]="{'isg-hidden': !(currentUser)}">
    <app-admin-card #adminMenu class="admin-card"></app-admin-card>
  </div>
  <div class="topbar-user"
       [ngClass]="{'isg-hidden': !(currentUser)}">
    <app-user-card #userMenu></app-user-card>
  </div>
  <div class="topbar-help">
    <!--  <app-apps-card></app-apps-card> -->
    <app-help-card></app-help-card>
  </div>
</div>
